import { LoadingSkeleton } from 'sonata-react-components';

import { SkeletonStyled } from '@/components/ioSettings/Skeleton/skeleton.styled.ts';

const Skeleton = () => {
  return (
    <SkeletonStyled className="ioSettingsSkeleton">
      <div className="ioSettingsSkeleton__mediaChannel">
        <LoadingSkeleton height={88} width="100%" />
      </div>
      <div className="ioSettingsSkeleton__selectors">
        <LoadingSkeleton height={40} width="100%" />
        <LoadingSkeleton height={40} width="100%" />
        <LoadingSkeleton height={40} width={618} />
      </div>
      <div className="ioSettingsSkeleton__dayParting">
        <LoadingSkeleton height={385} width="100%" />
      </div>
      <div className="ioSettingsSkeleton__flightsContainer">
        {Array.from({ length: 3 }).map((_, index) => (
          <div className="ioSettingsSkeleton__flights" key={index}>
            <LoadingSkeleton height={40} key={index} width={513} />
            <LoadingSkeleton height={40} key={index} width="100%" />
            <LoadingSkeleton height={40} key={index} width="100%" />
          </div>
        ))}
      </div>
      <div className="ioSettingsSkeleton__advancedContainer">
        {Array.from({ length: 2 }).map((_, index) => (
          <div className="ioSettingsSkeleton__advanced" key={index}>
            <LoadingSkeleton height={40} key={index} width="100%" />
            <LoadingSkeleton height={40} key={index} width="100%" />
            <LoadingSkeleton height={40} key={index} width="100%" />
          </div>
        ))}
        <LoadingSkeleton height={40} width={340} />
      </div>
    </SkeletonStyled>
  );
};

export default Skeleton;
